export default "__VITE_ASSET__DZ2oNVG0__"